import React from 'react';
import isNil from 'lodash/isNil';
import {
  formatDate,
} from 'utils/date';

type Part = 'root' | 'label' | 'date';

type Props = {
  effectiveFrom?: string | null;
  effectiveTill?: string | null;
  classes?: Partial<Record<Part, string>>;
};

export default function EligibilityEffective({
  effectiveFrom,
  effectiveTill,
  classes,
}: Props) {
  const hasFrom = !isNil(effectiveFrom);
  const hasTill = !isNil(effectiveTill);

  return (
    <span className={classes?.root}>
      {hasFrom && hasTill && (
        <>
          <span className={classes?.label}>Effective: </span>
          <span className={classes?.date}>{formatDate(effectiveFrom)}</span>
          <span className={classes?.label}> - </span>
          <span className={classes?.date}>{formatDate(effectiveTill)}</span>
        </>
      )}
      {hasFrom && !hasTill && (
        <>
          <span className={classes?.label}>Effective From </span>
          <span className={classes?.date}>{formatDate(effectiveFrom)}</span>
        </>
      )}
      {!hasFrom && hasTill && (
        <>
          <span className={classes?.label}>Effective Until </span>
          <span className={classes?.date}>{formatDate(effectiveTill)}</span>
        </>
      )}
      {!hasFrom && !hasTill && (
        <span className={classes?.label}>Effective Dates Not Given</span>
      )}
    </span>
  );
}
